   /*=========================================================================================
  File Name: state.js
  Description: Menus Store Main File
  ----------------------------------------------------------------------------------------
  Item Name: Menus State Module
  Author: Tan Tran
==========================================================================================*/

import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
export default {
    namespaced: true,
    state : state,
    mutations : mutations,
    actions : actions,
    getters : getters
}